/* eslint-disable no-unused-expressions */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useCallback, useEffect } from 'react';
import Grid from '../../../../SharedModules/Table/TableGridWithFeatures';
import { hideColumns } from './TableHeader';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';

const TableComponent = ({
  setSelectedRow,
  searchByDrugNameTableData,
  gridApi,
  columnName,
  rowSelection,
  fullScreenView,
  onSelect,
  emptyTableError,
  frameworkComponents,
  handleFullScreenView,
  handleFullScreenViewClick,
  fileName,
  gridHeight,
  exportFile,
  handleAddNewRow,
  helpMessage,
  singleClickEdit,
  suppressCellFocus,
  onCellFocused,
  selectionRows,
  rowClassRules,
  onGridReady,
  childPopup,
}) => {
  const onSelectionChanged = useCallback((e) => {
    // setSelectedRow(e.api.getSelectedRows());
  }, []);

  useEffect(() => {
    gridApi && gridApi.setFilterModel(null);
  }, [gridApi]);

  return (
    <>
      <div className="table-container mt-2">
        <DisplayErrorMessages errorMessages={emptyTableError || []} />
        <Grid
          gridCall={onGridReady}
          rowData={
            searchByDrugNameTableData?.length > 0
              ? searchByDrugNameTableData
              : []
          }
          columnDefs={columnName}
          defaultCol={{ editable: false }}
          rowSelection={rowSelection}
          onSelectionChanged={
            selectionRows ? null : (e) => onSelectionChanged(e)
          }
          frameworkComponents={frameworkComponents}
          handleFullScreenView={handleFullScreenView}
          exportFile={exportFile}
          gridHeight={gridHeight}
          onSelect={selectionRows ? null : onSelect}
          fullScreenView={fullScreenView}
          handleFullScreenViewClick={handleFullScreenViewClick}
          fileName={fileName}
          handleAddNewRow={handleAddNewRow}
          helpMessage={helpMessage}
          singleClickEdit={singleClickEdit}
          suppressCellFocus={suppressCellFocus}
          onCellFocused={onCellFocused}
          rowClassRules={rowClassRules}
          hideColumnsInPdf={hideColumns}
          childPopup={childPopup}
        />
      </div>
    </>
  );
};

export default TableComponent;
